import { HorseModel } from './HorseModel';
import { Constants } from '../../util/Constants';

export class HorsePackagedTipsModel {
  id: number;
  raceNum: number;
  raceId: number;
  horses: Array<HorseModel>;
  notes: string;
  keyRace: boolean;
  profitMargin: string;
  dividend: number;
  countScore: boolean;
  image1: string;
  image2: string;
  image3: string;

  constructor(id: number, raceNum: number, raceId: number, horses: Array<HorseModel>, notes: string, keyRace: boolean,
     profitMargin: string, dividend: number, countScore: boolean, image1: string, image2: string, image3: string) {
    this.id = id;
    this.raceNum = raceNum;
    this.raceId = raceId;
    this.horses = horses;
    this.notes = notes;
    this.keyRace = keyRace;
    this.profitMargin = profitMargin;
    this.dividend = dividend;
    this.countScore = countScore;
    this.image1 = image1;
    this.image2 = image2;
    this.image3 = image3;
  }

  isPackagedTipsFilled() {
    let numOfFilledHorse = 0;
    for (let horse of this.horses) {
      if (horse.num != 0) {
        numOfFilledHorse++;
      }
    }
    return (numOfFilledHorse >= Constants.MIN_NUM_OF_SELECTED_HORSE);
  }

  isNumOfHorsesExceedLimit(totalNumOfHorse: number) {
    if (totalNumOfHorse <= 6) {
      let numOfFilledHorse = 0;
      for (let i = 0; i < 4; i++) {
        if (this.horses[i].num != 0) {
          numOfFilledHorse++;
        }
      }
      return (numOfFilledHorse > Constants.MAX_NUM_OF_SELECTED_HORSE_FOR_LESS_THEN_SIX_HORSES_RACE);
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/model/horse/HorsePackagedTipsModel.ts